import { privateApi } from "./axios";

export const getBanks = async () => {
    try {
        const response = await privateApi.get("api/banks");
        return response;
    } catch (error) {
        throw error;
    }
}

export const getBankDeposit = async (id: number, startDate: string, endDate: string) => {
    try {
        const response = await privateApi.get(`api/banks/${id}/bankdeposit?startDate=${startDate}&endDate=${endDate}`);
        return response;
    }catch (error) {
        throw error;
    }
}

export const getSepa = async (id: number) => {
    try {
        const response = await privateApi.get(`api/banks/${id}/xml`);
        return response;
    } catch (error) {
        throw error;
    }
}